import React from 'react';
import '../styles/ChatbotPage.css';
import Navbar from '../components/Navbar';

const ChatbotPage = () => {
  return (
    <>
      <Navbar /> {/* ✅ Show the Navbar */}
      <div className="chatbot-page">
        <div className="assistant-header">
          <div className="avatar"></div>
          <div>
            <div className="assistant-name">Assistant</div>
            <div className="assistant-message">How can I help you today?</div>
          </div>
        </div>

        <div className="recent-title">Recent Conversations</div>

        <div className="conversation-list">
          <div className="conversation-item">
            <span className="emoji">💬</span>
            <div>
              <div className="conversation-title">Order Status</div>
              <div className="conversation-subtext">What is the status of my order?</div>
            </div>
          </div>

          <div className="conversation-item">
            <span className="emoji">🛠️</span>
            <div>
              <div className="conversation-title">Troubleshooting</div>
              <div className="conversation-subtext">Help with device issues</div>
            </div>
          </div>

          <div className="conversation-item">
            <span className="emoji">📅</span>
            <div>
              <div className="conversation-title">Schedule Reminder</div>
              <div className="conversation-subtext">Set a reminder for my meeting</div>
            </div>
          </div>
        </div>

        <div className="chat-input-area">
          <input className="chat-input" placeholder="Ask me anything" />
          <button className="send-button">Send</button>
        </div>
      </div>
    </>
  );
};

export default ChatbotPage;
